import { COLORS } from '../../../../utils/Application_Constants';

export default function CellLink({ href, label, onClick }) {
    return (
        <a
            href={href}
            title={label}
            target="_blank"
            style={{
                color: COLORS.LT_JOURNEY,
                textDecoration: 'underline',
                display: 'flex',
                alignItems: 'center',
            }}
            rel="noreferrer"
            onClick={onClick}
        >
            {label}
        </a>
    );
}
